import apiMiddleware from "../../../api/apiMiddleware";

const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `attraction-categories?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

const create = async (data) => {
  const response = await apiMiddleware.post("attraction-categories", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

const getById = async (id) => {
  const response = await apiMiddleware.get(`attraction-categories/${id}`);
  return response.data;
};

const update = async ({ id, data }) => {
  const response = await apiMiddleware.post(
    `attraction-categories/${id}?_method=PUT`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

const deleteAttractionCategory = async (id) => {
  const response = await apiMiddleware.delete(`attraction-categories/${id}`);
  return response.data;
};

export { list, create, getById, update, deleteAttractionCategory };
